// extracted by mini-css-extract-plugin
export var brand = "_8u-9";
export var compact = "_8u-6";
export var extraSmall = "_8u-7";
export var icon = "_8u-0";
export var large = "_8u-4";
export var light = "_8u-1";
export var medium = "_8u-5";
export var outline = "_8u-b";
export var primaryDark = "_8u-a";
export var primaryLight = "_8u-8";
export var primaryModern = "_8u-c";
export var success = "_8u-2";
export var successSolid = "_8u-3";